export const getMissingFieldsStep0 = (
  delegation,
  confirmEmail,
  confirmTelephone
) => {
  const missing = [];

  if (!delegation?.personType) missing.push("personType");
  if (!delegation?.email) missing.push("email");
  if (!delegation?.telephone) missing.push("telephone");

  // campi conferma
  if (!confirmEmail) missing.push("confirm_email");
  if (!confirmTelephone) missing.push("confirm_telephone");

  // controlli di corrispondenza
  if (delegation?.email && confirmEmail && delegation.email !== confirmEmail) {
    missing.push("confirm_email_mismatch");
  }

  if (
    delegation?.telephone &&
    confirmTelephone &&
    delegation.telephone !== confirmTelephone
  ) {
    missing.push("confirm_telephone_mismatch");
  }

  return missing;
};
